import { ChangeDetectionStrategy, Component, inject, input, model, signal, Signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { FormGroup, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormFactoryService } from '../../services/utility/form-factory.service';
import { AbstractToggleSidePanelComponent } from '../abstract-toggle-side-panel/abstract-toggle-side-panel';
import { AsyncApiService } from '@spike/core';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { IsinValue } from '../../models/isin-value.model';
import { ConfirmationDialogService } from '../../services/utility/confirmation-dialog.service';
import { IsinValueFormComponent } from '../../forms/isin-value-form/isin-value-form';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-isin-value-side-panel',
  providers:[],
  imports: [CommonModule, FormsModule, Button, Drawer,IsinValueFormComponent],
  templateUrl: './isin-value-side-panel.html'
})
export class IsinValueSidePanelComponent extends AbstractToggleSidePanelComponent<IsinValue>{
  private readonly formFactory = inject(FormFactoryService);
  private readonly asyncApi = inject(AsyncApiService);
  private readonly isinValueApiEnum = EntityApiEnum.FIN_ISIN_VALUE;
  private readonly confirmationService = inject(ConfirmationDialogService);

  override disabledFields: Signal<string[]> = signal([]);
  protected override buildFormArrays(data: IsinValue): void {}

  public readonly finIsinId = input.required<number>();
  public readonly form: FormGroup<any> =this.formFactory.createIsinValueForm();
  public readonly data = model<IsinValue>();

  async onSaveClicked() {
    const isinId = this.finIsinId();

    this.form.markAllAsTouched();
    if (this.form.valid) {
      const toSaveData = {...this.form.getRawValue(), finIsinId: isinId} as IsinValue;
      const savedData: IsinValue = await this.asyncApi.save(this.isinValueApiEnum, toSaveData, toSaveData.finIsinValueId);
      this.onSave.emit(savedData);
      this.data.set(savedData);
    }
  }

   public async onDeleteClicked() {
    const data = this.data();
    await new Promise<void>((resolve) => {
      this.confirmationService.show('Sei sicuro di voler eliminare questo valore?', async () => {
          await this.asyncApi.deleteById(this.isinValueApiEnum, data?.finIsinValueId!);
          this.onDelete.emit();
          resolve();
      });
    });
  }

}